import { render } from "./SkuSetup.vue?vue&type=template&id=9d990268&scoped=true"
import script from "./SkuSetup.vue?vue&type=script&lang=js"
export * from "./SkuSetup.vue?vue&type=script&lang=js"

import "./SkuSetup.vue?vue&type=style&index=0&id=9d990268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d990268"]])

export default __exports__